import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface FileHandle {
  file: File,
  url: SafeUrl
}

@Directive({
  selector: '[appDragDropFileOffer]'
})
export class DragDropFileOfferDirective {

  constructor(private el: ElementRef) { }

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.classList.add('file_dropped');
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.classList.remove('file_dropped');
  }

  // Drop listener

  // @HostListener('drop', ['$event']) public onDrop(evt) {
  //   evt.preventDefault();
  //   evt.stopPropagation();
  //   this.el.nativeElement.classList.remove('file_dropped');
  // }
}


